/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kimihurura 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Kamukina": ["Inyamibwa", "Isangano", "Isano", "Ituze", "Izuba", "Juru", "Nyenyeri", "Umurava", "Urumuri"],
  "Kimihurura": ["Amahoro", "Amajyambere", "Imihigo", "Intambwe", "Mutara", "Rugarama", "Ubumwe", "Umutekano", "Urwego"],
  "Rugando": ["Gasange", "Gasasa", "Marembo", "Rebero", "Taba"]
};